export enum LegPlanningTypesEnum {
    To_Be_Planned = 1,
    Trip = 2,
    Network = 3,
    StandBy = 4
};

export enum LegTypesEnum {
    Collection = 1,
    Delivery = 2,
    Direct = 3,
    Shuttle = 4,
    Network = 5,
    Delivery_To_Partner = 6,
    Collection_From_Partner = 7,
    Shuttle_To_Partner = 8,
    Shuttle_From_Partner = 9
};

export enum LegStatusEnum {
	NOT_DISPATCHABLE = 1,
	DISPATCHABLE = 2,
	DISPATCHING = 3,
	DISPATCHED = 4,
	ERROR = 5,
	REPLANNING = 6,
    HANDLED_ERROR = 7
};

export class Leg1Rules {
    public id: number | undefined = undefined;
    public businessFlowTypeId: number | undefined = undefined;
    public planningTypeId: number | undefined = undefined;
    public typeId : number | undefined = undefined;
    public tR: string | undefined = undefined;
    public tS: string | undefined = undefined;
};

export class Leg2Rules {
    public id: number | undefined = undefined;
    public businessFlowTypeId: number | undefined = undefined;
    public firstPlanningTypeId: number | undefined = undefined;
    public firstTypeId : number | undefined = undefined;
    public secondPlanningTypeId: number | undefined = undefined;
    public secondTypeId : number | undefined = undefined;
    public tR: string | undefined = undefined;
    public tS: string | undefined = undefined;
};

export class Leg3Rules {
    public id: number | undefined = undefined;
    public businessFlowTypeId: number | undefined = undefined;
    public firstPlanningTypeId: number | undefined = undefined;
    public firstTypeId : number | undefined = undefined;
    public secondPlanningTypeId: number | undefined = undefined;
    public secondTypeId : number | undefined = undefined;
    public thirdPlanningTypeId: number | undefined = undefined;
    public thirdTypeId : number | undefined = undefined;
    public tR: string | undefined = undefined;
    public tS: string | undefined = undefined;
};